/**
 * ChecklistItem — Reusable checklist item (glyph + title + body).
 * Eliminates 3× repeated item markup + CSS in PermissionsScreen,
 * InstallBridgeScreen, PreparationScreen.
 */
import styles from "../styles/screen-atoms.module.css";

type Props = {
  glyph: React.ReactNode;
  title: string;
  body: string;
};

export function ChecklistItem({ glyph, title, body }: Props) {
  return (
    <>
      <div className={styles.ruleSoftNoMargin} />
      <div className={styles.item}>
        <div className={styles.glyph}>{glyph}</div>
        <div>
          <div className={styles.itemTitle}>{title}</div>
          <div className={styles.itemBody}>{body}</div>
        </div>
      </div>
    </>
  );
}
